import React, { FC, useState, useEffect, useRef } from 'react'
import { observer } from 'mobx-react'
import { RefresherEventDetail } from '@ionic/core'
import { RouteComponentProps } from 'react-router-dom'
import { UseHeader, Empty } from '@cps'
import { orderListMobx, orderMobx } from 'restaurant'
import { memberMobx, storeMobx, themeMobx, authConfigMobx } from '@mobxStore'
import orderApi from '@api/order.api'
import { IonHeader, IonPage, IonContent, IonRefresher, IonRefresherContent, IonInfiniteScroll, IonInfiniteScrollContent, useIonViewWillEnter } from '@ionic/react'
import OrdersNoLogin from './component/orderNoLogin'
import { chevronDownCircleOutline } from 'ionicons/icons'
import OrderItem from './component/orderItem'
import OrderTabs from './component/OrderTabs'
import { RestoreOrderController, OrdersController, MktController } from '@ctrls/index'
import { keyBy, each } from '@dt/fe-utils/dist/lodash'
import { ddayjs } from '@dt/fe-utils'
import { useHistoryNew, getCouponsInfo, useHistoryListen } from '@utils'
import ActivityApi from '@api/activity.api'
import './index.scss'
// interface
import axios from 'axios'

import noOrdersImg from '@img/no-orders.png'
import { refundMobx } from '@mobx/order'
const CancelToken = axios.CancelToken
let cencalRequist = null
interface IProps extends IPage, RouteComponentProps {
}
const Orders: FC<IProps> = ({ pageName, match }: IProps) => {
  const orderTabsData = [
    {
      label: i18n.t('order.currentOrder'),
      value: 'today',
      keys: [],
      children: []
    },
    {
      label: i18n.t('order.historicalOrder'),
      value: 'historical',
      keys: ['dc', 'mall', 'goods', 'cz'],
      children: bo === 'cn' ? [
        {
          label: i18n.t('order.meals'),
          value: 'dc'
        },
        {
          label: i18n.t('order.mall'),
          value: 'mall'
        },
        {
          label: i18n.t('order.virtualGoods'),
          value: 'goods'
        }, {
          label: i18n.t('order.recharge'),
          value: 'cz'
        }
      ] : [
        {
          label: i18n.t('order.meals'),
          value: 'dc'
        }, {
          label: i18n.t('order.virtualGoods'),
          value: 'goods'
        }, {
          label: i18n.t('order.recharge'),
          value: 'cz'
        }
      ]
    },
  ]
  const { pageLevel } = match.params as any
  const [page, setPage] = useState<number>(0)
  const [starTime, setStartTime] = useState<string>()
  // 自动跳转订单详情
  const [canShowDertail, setCanShowDetail] = useState<boolean>(false)
  const [canget, setCanget] = useState<boolean>(true)
  const [orderList, setOrderList] = useState<any[]>([])
  const [_loading, setLoading] = useState(false)
  const [couponMap, setCouponMap] = useState<any>({})
  // 是否展示再来一单
  const [isShowBA, setShowBA] = useState<boolean>(false)
  const contentRef = useRef(null)
  const history = useHistoryNew()
  const size: number = 20 // 接口已定死20条
  // 查看更遥远订单控制
  const [showMoreBtn, setShowMoreBtn] = useState<boolean>(false) // 显示更遥远按钮
  const [monthNum, setMonthNum] = useState<number>(0) // 月份倍数，用于加载6个月的记录

  useEffect(() => {
    orderListMobx.state = 'today'
    refundMobx.getMobileRefundPlan()
  }, [])
  const filterFunc = (order: IOrder) => {
    if (order.status === 'Pending' && order?.payMode === 0) {
      return false
    }
    // 非当前桌码的桌码订单不展示
    if (order.status === 'Pending' && order.tableCode && (String(Config.TABLECODE) !== '0' && String(Config.TABLECODE) !== order.tableCode)) {
      return false
    }
    // 桌码订单 不在门的码下展示
    if (order.status === 'Pending' && order.tableCode && ['store'].includes(Config.codeType)) {
      return false
    }
    if (order.status === 'Timeout' && ['cz', 'goods', 'mall'].includes(order?.ordersType)) {
      return false
    }
    if (!['Success', 'refund'].includes(order?.status) && ['cz', 'goods'].includes(order?.ordersType)) {
      return false
    }
    if (orderListMobx.state === 'today' ? !order?.isToday : order?.isToday === 1) {
      return false
    }

    return true
  }
  const OrderItemList = (orders: IOrder[]) => {
    // 不展示先付费且待支付的订单
    return orders.map((order, index) => {
      const isShow: boolean = filterFunc(order)
      return isShow && <OrderItem key={`${order.ordersId}_${index}`} showBA={isShowBA} info={order} couponMap={couponMap} />
    })
  }
  const doRefresh = (event: CustomEvent<RefresherEventDetail>) => {
    setTimeout(() => {
      event.detail.complete()
      getOrderList(true)
    }, 500)
  }
  const loadData = (ev: any) => {
    if (canget) {
      setTimeout(() => {
        getOrderList(false)
        ev.target.complete()
      }, 500)
    }
  }
  // 切换顶部导航
  const tabsChange = (type: string) => {
    if (type === orderListMobx.state) return
    setCanget(false)
    setLoading(false)
    setShowMoreBtn(false)
    setCouponMap({})
    orderListMobx.state = type
    getOrderList(true)
    contentRef.current && contentRef.current.scrollToTop()
  }
  // 订单列表请求
  const getOrderList = (isInit: boolean) => {
    if (!Config.token || (bo === 'cn' && !memberMobx?.memberInfo?.memberId)) return
    const newPage: number = isInit ? 0 : page
    const newNum: number = isInit ? 0 : monthNum
    if (isInit) {
      setOrderList([])
      setPage(newPage)
      setMonthNum(newNum)
    }
    const timer = new Date().valueOf()
    const startAddTime = ddayjs(timer, 'client').subtract(90 * newNum + 89, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss')
    const endAddTime = ddayjs(timer, 'client').subtract(90 * newNum, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss')
    orderApi.getOrdersListByMemberWithToday({
      startAddTime,
      endAddTime,
      /** 订单展示退款状态 */
      showApplyRefund: 1,
      ordersType: orderListMobx.state === 'today' ? ['dc', 'mall', 'goods', 'cz'] : [orderListMobx.state],
      pageSize: size,
      pageNo: newPage
    }, {
      cancelToken: new CancelToken(function executor (c) {
        cencalRequist && cencalRequist()
        // An executor function receives a cancel function as a parameter
        cencalRequist = c
      })
    }).then((res: any) => {
      if (!res.error) {
        let result = res.result ? res.result.content : []
        if (orderListMobx.state === 'dc' || orderListMobx.state === 'mall' || orderListMobx.state === 'today') {
          let isFirstAccepted = true
          result = result.filter(order => {
            // 是否是自提待接单
            const isAccepted = isFirstAccepted && order.status === 'NotAccepted' && order.eatType === 'pickup'
            isFirstAccepted = false
            return order.nono || isAccepted
          }).sort((a, b) => new Date(b.addTime).getTime() - new Date(a.addTime).getTime())
        }
        const arr: any[] = []
        let couponIds: any[] = []
        each(result, (data) => {
          arr.push(OrdersController.transformData(data, orderListMobx.state))
          if (orderListMobx.state === 'goods' && data.eatType === 'redeemCouponByMoney') {
            couponIds = [...couponIds, ...getCouponsInfo(data?.details?.[0]?.coupons, 'id')]
          }
        })
        if (couponIds.length) getCouponDetails(couponIds)
        setOrderList(isInit ? arr : orderList.concat(arr))
        if (newPage + 1 >= res.result?.totalPages) {
          setCanget(false)
          setShowMoreBtn(orderListMobx.state !== 'today')
        } else {
          setCanget(true)
          setPage(newPage + 1)
          setShowMoreBtn(false)
        }
      }
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      cencalRequist = null
      setLoading(true)
    })
  }
  const getCouponDetails = async (ids: any) => {
    const res = await ActivityApi.getCouponsList({ couponIds: ids })
    if (res?.length > 0) {
      setCouponMap({ ...couponMap, ...keyBy(res, 'couponId') })
    }
  }

  /** 多点单如果有下单，就不允许再来一单 */
  const checkCanBuyAgain = async () => {
    if (Config.codeType === 'table' && storeMobx.info.openMultiPersonOrdering) {
      const order = await orderListMobx.getTabelCodeOrder(Config.TABLECODE)
      setShowBA(!order.length)
      return
    }
    setShowBA(true)
  }
  const onBack = () => {
    MktController.goBack(history)
  }

  /** 判断当前订单能否去结算页，不同channel下单的需要做限制 */
  const checkCanToCart = (info) => {
    switch (Config.codeType) {
      case 'brand':
        return ['mobile', 'selfDelivery'].includes(info.channel)
      case 'store':
      case 'table':
        return ['mobile'].includes(info.channel)
      default:
        return false
    }
  }

  // 跳转订单详情
  const gotoDetail = (info) => {
    const { status } = info
    // 品牌码门店码下不自动进入桌码订单
    const isTableOrder = !!info?.tableCode && ['Pending', 'NotAccepted'].includes(status) && Config.codeType !== 'table'
    if (isTableOrder) return
    /** 判断是否是小程序 需要跳到原生的订单结果页 */
    if (status === 'Pending' || status === 'NotAccepted') {
      // 需要更改这笔等待
      if (checkCanToCart(info)) {
        orderMobx.init(info.ordersId).then(() => {
          RestoreOrderController.checkout()
        })
        return
      }
    }
    let pathname = `/result/${info.ordersId}`
    history.push({
      pathname,
      state: {
        fromList: true
      }
    })
  }
  const getMoreList = () => {
    setPage(0)
    setShowMoreBtn(false)
    setMonthNum(monthNum + 1)
  }
  useIonViewWillEnter(() => {
    getOrderList(true)
    checkCanBuyAgain()
  })
  useHistoryListen((pathname: string) => {
    // 从底部导航进入flag可以打开当前订单
    if (pathname === '/orders' && ['/home', '/menu', '/orders', '/my', '/giftCard', '/mall'].includes(history.getPrevState())) {
      setCanShowDetail(true)
    } else {
      setCanShowDetail(false)
    }
  })
  useEffect(() => {
    monthNum > 0 && getOrderList(false)
  }, [monthNum])
  useEffect(() => {
    // 自动跳转第一条当前订单
    if (canShowDertail && orderListMobx.state === 'today' && orderList.filter(filterFunc).length === 1) {
      gotoDetail(orderList.filter(filterFunc)?.[0])
      setCanShowDetail(false)
    }
  }, [canShowDertail, orderList])
  return (
    <IonPage title={pageName} className='orders-page'>
      {
        pageLevel === '2' && <UseHeader className='orders-header' onBack={onBack} title={i18n.t('common.orders')}></UseHeader>
      }
      <IonHeader>
        <div className='nav-bar'>
          <OrderTabs data={orderTabsData} value={orderListMobx.state} onChange={tabsChange}></OrderTabs>
        </div>
      </IonHeader>
      <IonContent
        ref={contentRef}
        scrollEvents
        forceOverscroll
      >
        {!(!Config.token || (bo === 'cn' && !memberMobx?.memberInfo?.memberId)) ? (
          <div className='order-list-warp'>
            <IonRefresher slot='fixed' onIonRefresh={doRefresh}>
              <IonRefresherContent
                pullingIcon={chevronDownCircleOutline}
                pullingText={i18n.t('order.pullrefresh')}
              />
            </IonRefresher>
            <div className='order-item-left order-measure-height'>
              {_loading ? orderList.filter(filterFunc).length
                ? OrderItemList(orderList)
                : (
                  <div className='no-order-item'>
                    <Empty
                      msg={themeMobx.data?.abnormalStateSetting?.[1]?.subName || ''}
                      iconType='dicon'
                      iconName={themeMobx?.data?.abnormalStateSetting[1]?.icon}
                      picUrl={themeMobx?.data?.abnormalStateSetting[1]?.pic || noOrdersImg}
                      height='55vh'
                      btnText={i18n.t('decoration.goMenu')}
                      btnAction={() => history.replace('/menu')}
                      btnBg={authConfigMobx.isNoWorry}
                    />
                  </div>
                )
                : <div className='no-order-item'><span className='no-order-text'>{i18n.t('invoice.searching')}...</span></div>}

              {showMoreBtn && (
                <div className='more-month-wrapper' style={{ marginTop: orderList.filter(filterFunc).length ? '10px' : 'auto' }} onClick={getMoreList}>
                  <div className='more-month-btn'>{i18n.t('result.getLongOrder')}</div>
                </div>
              )}
            </div>
            {
              canget &&
                <IonInfiniteScroll threshold='100px' onIonInfinite={(ev) => loadData(ev)}>
                  <IonInfiniteScrollContent
                    loadingSpinner='bubbles'
                    loadingText={i18n.t('order.loadmore')}
                  >
                  </IonInfiniteScrollContent>
                </IonInfiniteScroll>
            }
          </div>
        ) : (<OrdersNoLogin />)}
      </IonContent>
    </IonPage>
  )
}
export default observer(Orders)
